export enum PlayByPlayIncidentTypes {
    Possesion = 1,
    ThrowIn = 2,
    GoalKick = 3,
    Corner = 4,
    FreeKick = 5,
    Goal = 6,
    YellowCard = 7,
    ShotOnGoal = 8,
    PenaltyKick = 13,
    RedCard = 15
}